module.exports = __webpack_public_path__ + "static/img/watch-white.cc9dc874.png";